import React, { createContext, useContext } from 'react';
import { createDevicesStorage } from './mediaSettingsStorage';

const deviceStorage = createDevicesStorage();

export interface IJazzGlobalContext {
  devices: {
    getAudioInput: () => string | undefined;
    setAudioInput: (value: string | undefined) => void;
    getVideoInput: () => string | undefined;
    setVideoInput: (value: string | undefined) => void;
    getAudioOutput: () => string | undefined;
    setAudioOutput: (value: string | undefined) => void;
  };
}

export const initialContext = {
  devices: deviceStorage
};

export const JazzGlobalContext = createContext<IJazzGlobalContext>(undefined);

export function useJazzGlobalContext() {
  const result = useContext(JazzGlobalContext);

  if (!result) {
    throw new Error('JazzGlobalContext is required');
  }

  return result;
}

export const JazzGlobalContextProvider = ({ children }) => {
  return (
    <JazzGlobalContext.Provider value={initialContext}>{children}</JazzGlobalContext.Provider>
  );
};
